import { Controller } from '@hotwired/stimulus';

// Filtre d'une liste par pastilles : chaque élément porte data-kind (une ou
// plusieurs clés séparées par des espaces), chaque pastille son paramètre
// kind (« all » : tout) ; la pastille choisie est marquée (aria-pressed) et
// appliquée dès l'ouverture, puis à chaque élément remplacé (Turbo Stream).
// Facultatif : groupes masqués quand tous leurs éléments le sont (cible
// group), message sans élément (cible none), champ qui reçoit la clé (cible
// current) ; cases cochées d'un élément masqué décochées (événement change).
export default class extends Controller {
    static targets = ['item', 'button', 'group', 'none', 'current'];

    connect() {
        const pressed = this.buttonTargets.find((button) => button.getAttribute('aria-pressed') === 'true');
        this.kind = pressed?.dataset.listFilterKindParam || 'all';
        this.apply();
    }

    filter({ params: { kind }, currentTarget }) {
        this.kind = kind;
        this.buttonTargets.forEach((button) => button.setAttribute('aria-pressed', button === currentTarget ? 'true' : 'false'));
        this.apply();
    }

    itemTargetConnected(item) {
        if (this.kind === undefined) return;

        this.show(item);
        this.refresh();
    }

    apply() {
        this.itemTargets.forEach((item) => this.show(item));
        this.refresh();
    }

    show(item) {
        const keys = (item.dataset.kind || '').split(' ');
        item.hidden = this.kind !== 'all' && !keys.includes(this.kind);
        if (!item.hidden) return;

        item.querySelectorAll('input[type="checkbox"]:checked').forEach((box) => {
            box.checked = false;
            box.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    refresh() {
        this.groupTargets.forEach((group) => {
            group.hidden = !this.itemTargets.some((item) => group.contains(item) && !item.hidden);
        });
        if (this.hasNoneTarget) this.noneTarget.hidden = this.itemTargets.some((item) => !item.hidden);
        this.currentTargets.forEach((field) => { field.value = this.kind; });
    }
}
